module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('prepare-problem-table', {
    attrs: {
      "tableData": _vm.dshProblemList
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctitle"
  }, [_c('h2', [_vm._v("待审核题目")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3081d9b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/prepareProblemList.vue
// module id = 638
// module chunks = 4